<!--
    描述：订阅查看工具-查询tab页列表页面
    时间：2020-06-16
    Created by yefan
-->
<template>
    <div class="w-filter-layout">
        <!-- 延迟顶部点击筛选栏 -->
        <div class="w-filter-header"
             v-if="showFilter">
            <filterArea @doFilter="doSearch"
                        ref="filterArea"></filterArea>
        </div>

        <!-- 内容区域 -->
        <div class="w-filter-content w-page-main">
            <div class="w-page-header">
                <searchArea v-model="filterRules.sname"
                            placeholderName="材料名称"
                            :showFilter="true"
                            :showMore="false"
                            @on-search="doSearch"
                            @on-refresh="doRefresh"
                            @on-filter="showFilter = !showFilter"></searchArea>
            </div>
            <!-- 表格主体 -->
            <div class="w-page-container">
                <priceTable ref="priceTable"
                            :showFilter="showFilter"></priceTable>

            </div>
        </div>
    </div>
</template>

<script>
    import priceTable from './components/priceTable'
    import filterArea from './components/filterArea.vue'

    export default {
        components: {priceTable, filterArea},
        data() {
            return {
                showFilter: true,
                filterRules: {
                    sname: '',
                    priceTypeList: [],
                    yearList: [],
                    areaList: [],
                },
                searchForm: {
                    sname: ''
                },
            }
        },

        methods: {
            // 搜索查询
            doSearch(arr) {
                // 筛选时的赋值处理
                if (arr) {
                    // 价格类型
                    this.filterRules.priceTypeList = [
                        ...arr[0].list.map(x => x.value)
                    ];

                    // 年份
                    this.filterRules.yearList = [
                        ...arr[1].list.map(x => x.value)
                    ];

                    // 地区
                    this.filterRules.areaList = [...arr[2].list.map(x => x.value)]
                }

                this.$refs.priceTable.queryParams = Object.assign(
                    {},
                    this.filterRules
                );
                this.$refs.priceTable.getlistData()
            },

            // 点击刷新
            doRefresh() {
                this.$refs.filterArea.filterColumns.forEach(x => {
                    x.checkAll = true;
                    x.list.filter(y => (y.checked = false))
                });

                // 重置变量
                this.filterRules.sname = '';
                this.filterRules.yearList = [];
                this.filterRules.areaList = [];
                this.filterRules.priceTypeList = [];
                this.$refs.priceTable.queryParams = Object.assign({}, this.filterRules);
                this.$refs.priceTable.getlistData()
            },
        }
    }
</script>

<style scoped>
</style>